import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Flower2 } from "lucide-react";
import { BRAND, waLink } from "../../data";

const LINKS = [
  { label: "Layanan", href: "/#layanan" },
  { label: "Paket", href: "/#paket" },
  { label: "Kenapa Kami", href: "/#kenapa" },
  { label: "Galeri", href: "/#galeri" },
  { label: "Testimoni", href: "/#testimoni" },
  { label: "Area Layanan", href: "/#area" },
  { label: "Peta", href: "/#peta" },
  { label: "FAQ", href: "/#faq" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#faf7f2]/85 backdrop-blur-xl border-b border-[#e5d9c5]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-logo"
          className="flex items-center gap-2 group"
        >
          <Flower2
            className={`h-6 w-6 ${scrolled ? "text-[#8b5a2b]" : "text-[#b8862f]"}`}
            strokeWidth={1.5}
          />
          <span
            className={`font-display text-xl sm:text-2xl leading-none tracking-tight ${
              scrolled ? "text-[#2c1e16]" : "text-[#2c1e16]"
            }`}
          >
            {BRAND}
          </span>
        </Link>

        <nav className="hidden xl:flex items-center gap-6">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="link-underline text-sm text-[#5c4033] hover:text-[#2c1e16] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href={waLink("Halo Javanese Spa Jogja, saya ingin booking Massage panggilan.")}
            target="_blank"
            rel="noreferrer"
            data-testid="header-booking-btn"
            className="rounded-full bg-[#5c4033] text-[#faf7f2] px-6 py-2.5 text-sm hover:bg-[#2c1e16] transition-colors"
          >
            Booking Sekarang
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="xl:hidden p-2 text-[#2c1e16]"
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="xl:hidden bg-[#faf7f2] border-t border-[#e5d9c5] px-5 py-6 flex flex-col gap-4"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-base text-[#2c1e16]"
            >
              {l.label}
            </a>
          ))}
          <a
            href={waLink("Halo Javanese Spa Jogja, saya ingin booking Massage panggilan.")}
            target="_blank"
            rel="noreferrer"
            className="mt-2 rounded-full bg-[#5c4033] text-[#faf7f2] px-6 py-3 text-center text-sm"
          >
            Booking via WhatsApp
          </a>
        </div>
      )}
    </header>
  );
};
